import React from 'react'

export const TemplateProviSignContext = React.createContext({})

export const TemplateProviSignConsumer = TemplateProviSignContext.Consumer
